export const salesSimulationFullPage = '/simulate/sales-simulation-report';
